import React from 'react';
import {get} from 'lodash';

import {BonusEligibleUntil} from '/component/partial/report/BonusEligibleUntil';
import {useTranslation} from '/provider/TranslationProvider';
interface QsbEligibleUntilProps {
  item: {
    newOrderingEntitiesCount?: number | null;
    qsbFqv?: string | null;
    qsbRemainingEligibility?: number | null;
  };
}

export const QsbEligibleUntil: React.FC<QsbEligibleUntilProps> = ({
  item = {},
}) => {
  const itemData = {
    newOrderingEntitiesCount: get(item, 'newOrderingEntitiesCount', null),
    fqv: get(item, 'qsbFqv', null),
    remainingEligibility: get(item, 'qsbRemainingEligibility', null),
  };

  const {ts} = useTranslation('report.record.qsbEligibleUntil');

  return (
    <BonusEligibleUntil
      item={itemData}
      orderingEntitiesName={ts('qsbOrderingEntities', 'QSB Ordering Entities')}
      fqvName={ts('qsbFqv', 'QSB FQV')}
    />
  );
};
